/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects"

import {
  ADD_TEAM_SCHEDULING,
  AGENT_OFFICE_VACANCY_LIST,
  AGENT_VANCANY_LIST,
  LOAD_EVENT_TEAM_SCHEDULING,
  LOAD_FREELANCER_LIST,
  LOAD_RECORDS_META_DATA,
  LOAD_TEAM_SCHEDULING,
  LOAD_TEAM_SCHEDULING_SERVICE,
  REMOVE_TEAM_SERVICE,
  SHOOTER_HISTORY_LIST,
  TEAM_FINAL_COMMIT,
  UPDATE_TEAM_SCHEDULING,
  UPDATE_TEAM_SCHEDULING_SERVICE,
} from "./constants"

import {
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  addTeamSchedulingSuccess,
  loadTeamSchedling,
  loadTeamSchedlingSuccess,
  loadTeamSchedlingError,
  addTeamSchedulingError,
  loadShooterHistory,
  loadShooterHistorySuccess,
  loadShooterHistoryError,
  updateTeamSchedulingSuccess,
  updateTeamSchedulingError,
  teamFinalCommitSuccess,
  teamFinalCommitError,
  loadEventTeamSchedling,
  loadEventTeamSchedlingSuccess,
  loadEventTeamSchedlingError,
  loadAgentVacancy,
  loadAgentVacancySuccess,
  loadAgentVacancyError,
  loadAgentOfficeVacancy,
  loadAgentOfficeVacancySuccess,
  loadAgentOfficeVacancyError,
  loadFreelancerList,
  loadFreelancerListSuccess,
  loadFreelancerListError,
  loadTeamSchedlingService,
  loadTeamSchedlingServiceSuccess,
  loadTeamSchedlingServiceError,
  updateTeamSchedulingServiceSuccess,
  updateTeamSchedulingServiceError,
  removeTeamSchedulingServiceSuccess,
  removeTeamSchedulingServiceError,
} from "./actions"

import {
  loadRecordsMetaData,
  loadTeamSchedlingDetails,
  addTeamSchedulingDetails,
  loadShooterHistoryDetails,
  teamCommitDetails,
  updateTeamSchedulingDetails,
  loadEventTeamSchedlingDetails,
  loadAgentVacancyDetails,
  loadAgentOfficeVacancyDetails,
  loadFreelancerListDetails,
  loadTeamSchedlingServiceDetails,
  updateTeamSchedulingServiceDetails,
  removeTeamSchedulingServiceDetails,
} from "./remotes"

//Special Instructions
function* loadTeamSchedulingSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_TEAM_SCHEDULING),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadTeamSchedling(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadTeamSchedlingDetails, id)

        if (result) {
          yield put(loadTeamSchedlingSuccess(result.data))
        } else {
          yield put(loadTeamSchedlingError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadTeamSchedlingError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

//Freelancer details
function* loadFreelancerListSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_FREELANCER_LIST),
    })

    const { explicitLoad } = load
    const { record } = explicitLoad || {}
    yield put(loadFreelancerList(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadFreelancerListDetails, record)

        if (result) {
          yield put(loadFreelancerListSuccess(result.data))
        } else {
          yield put(loadFreelancerListError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadFreelancerListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}
//Team Schedule Service details
function* loadTeamScheduleServiceSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_TEAM_SCHEDULING_SERVICE),
    })

    const { explicitLoad } = load
    const { record } = explicitLoad || {}
    yield put(loadTeamSchedlingService(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadTeamSchedlingServiceDetails, record)

        if (result) {
          yield put(loadTeamSchedlingServiceSuccess(result.data))
        } else {
          yield put(loadTeamSchedlingServiceError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadTeamSchedlingServiceError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadAgentVacancyDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(AGENT_VANCANY_LIST),
    })

    const { explicitLoad } = load

    const { record } = explicitLoad || {}
    yield put(loadAgentVacancy(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadAgentVacancyDetails, record)

        if (result) {
          yield put(loadAgentVacancySuccess(result.data))
        } else {
          yield put(loadAgentVacancyError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadAgentVacancyError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadAgentOfficeVacancyDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(AGENT_OFFICE_VACANCY_LIST),
    })

    const { explicitLoad } = load

    const { record } = explicitLoad || {}
    yield put(loadAgentOfficeVacancy(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadAgentOfficeVacancyDetails, record)

        if (result) {
          yield put(loadAgentOfficeVacancySuccess(result.data))
        } else {
          yield put(loadAgentOfficeVacancyError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadAgentOfficeVacancyError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadEventTeamSchedulingSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_EVENT_TEAM_SCHEDULING),
    })

    const { explicitLoad } = load

    const { eventScheduling } = explicitLoad || {}
    yield put(loadEventTeamSchedling(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadEventTeamSchedlingDetails,
          eventScheduling
        )

        if (result) {
          yield put(loadEventTeamSchedlingSuccess(result.data))
        } else {
          yield put(loadEventTeamSchedlingError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadEventTeamSchedlingError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* addTeamSchedulingSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(ADD_TEAM_SCHEDULING),
    })
    const { teamScheduling } = create || {}

    if (create) {
      console.log("records", teamScheduling)
      try {
        yield call(addTeamSchedulingDetails, teamScheduling)

        var successVal = addTeamSchedulingSuccess(
          teamScheduling,
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          addTeamSchedulingError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* updateTeamSchedulingDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPDATE_TEAM_SCHEDULING_SERVICE),
    })
    const { teamScheduling } = create || {}

    if (create) {
      console.log("records", teamScheduling)
      try {
        yield call(updateTeamSchedulingServiceDetails, teamScheduling)

        var successVal = updateTeamSchedulingServiceSuccess(
          teamScheduling,
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          updateTeamSchedulingServiceError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}
function* removeTeamSchedulingDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(REMOVE_TEAM_SERVICE),
    })
    const { teamScheduling } = create || {}

    if (create) {
      console.log("records", teamScheduling)
      try {
        yield call(removeTeamSchedulingServiceDetails, teamScheduling)

        var successVal = removeTeamSchedulingServiceSuccess(
          teamScheduling,
          "Record Removed Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          removeTeamSchedulingServiceError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}
function* loadShooterHistorySaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(SHOOTER_HISTORY_LIST),
    })

    const { explicitLoad } = load

    const { empId } = explicitLoad || {}
    yield put(loadShooterHistory(explicitLoad.empId)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadShooterHistoryDetails, empId)

        if (result) {
          yield put(loadShooterHistorySuccess(result.data))
        } else {
          yield put(loadShooterHistoryError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadShooterHistoryError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* updateTeamSchedulingSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPDATE_TEAM_SCHEDULING),
    })
    const { teamScheduling } = create || {}

    if (create) {
      console.log("records", teamScheduling)
      try {
        yield call(updateTeamSchedulingDetails, teamScheduling)

        var successVal = updateTeamSchedulingSuccess(
          teamScheduling,
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          updateTeamSchedulingError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}
function* teamFinalCommitSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(TEAM_FINAL_COMMIT),
    })
    const { finalCommit } = create || {}

    if (create) {
      console.log("records", finalCommit)
      try {
        yield call(teamCommitDetails, finalCommit)

        var successVal = teamFinalCommitSuccess(
          finalCommit,
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          teamFinalCommitError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
      const employeeList = yield call(
        loadRecordsMetaData,
        "employee_list",
        "post"
      )
      const freelancerList = yield call(
        loadRecordsMetaData,
        "freelancer",
        "post"
      )
      // const freelancer = yield call(loadRecordsMetaData, "freelancer", "post")
      // const serviceList = yield call(
      //   loadRecordsMetaData,
      //   "service",
      //   "post"
      // )
      let recordsMetaData = {
        employeeListOptions:
          (employeeList &&
            employeeList.data &&
            employeeList.data.length > 0 &&
            employeeList.data
              .filter((_) => _.status === 1)
              .map((e) =>
                Object.assign(
                  {},
                  {
                    label: `${e.empCode} - ${e.name}`,
                    value: e._id,
                    empCode: e.empCode,
                    name: e.name,
                    designationId: e.designationId,
                    departmentId: e.departmentId,
                    designationName: e.designationName,
                  }
                )
              )) ||
          [],
        // serviceListOptions:
        // (serviceList &&
        //   serviceList.data &&
        //   serviceList.data.length > 0 &&
        //   serviceList.data
        //     .filter((_) => _.status === 1)
        //     .map((e) =>
        //       Object.assign(
        //         {},
        //         {
        //           label: e.serviceName,
        //           value: e._id,
        //         }
        //       )
        //     )) ||
        // [],
        freelancerData: freelancerList,
        freelancerOptions:
          (freelancerList &&
            freelancerList.data &&
            freelancerList.data.length > 0 &&
            freelancerList.data
              .filter((_) => _.status === 1)
              .map((e) =>
                Object.assign(
                  {},
                  {
                    label: e.freelancerName,
                    value: e._id,
                    freelancerCode: e.freelancerCode,
                    paymentDetails: e.paymentDetails,
                    vendorMembers: e.vendorMembers,
                    vendorType: e.vendorType,
                  }
                )
              )) ||
          [],
      }

      console.log("recordsMetaData-->", recordsMetaData)

      yield put(loadRecordsMetaDataSuccess(recordsMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadRecordsMetaDataSaga(),
    loadTeamSchedulingSaga(),
    addTeamSchedulingSaga(),
    loadShooterHistorySaga(),
    teamFinalCommitSaga(),
    updateTeamSchedulingSaga(),
    loadEventTeamSchedulingSaga(),
    loadAgentVacancyDetailsSaga(),
    loadAgentOfficeVacancyDetailsSaga(),
    updateTeamSchedulingDetailsSaga(),
    loadTeamScheduleServiceSaga(),
    loadFreelancerListSaga(),
    removeTeamSchedulingDetailsSaga()
  ])
}
